(function ($) {
  $('.mobileMenu').click(() => {
    if ($('.mobileMenu').hasClass('.mobileMenu--active')) {
      $('html').bind('touchmove', (e) => {
        e.preventDefault();
      });
      $('html').toggleClass('noscroll');
    } else {
      $('html').unbind('touchmove');
      $('html').toggleClass('noscroll');
    }
  });
}(jQuery));
